<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :send-function="onGroupCreateAndUpdate"
    :open-function="onOpen"
  >
    <BaseInput
      :label="localStorage.translations.pages['setting-free_documents']['dialogs_labels']['name']"
      v-model="name"
      :rules="['required', 'max100']"
      :placeholder="
        localStorage.translations.pages['setting-free_documents']['dialogs_labels']['name']
      "
    />
    <div>
      <label class="fw500 primary--text f14">{{
        localStorage.translations.pages['setting-free_documents']['dialogs_labels']['icon']
      }}</label>
      <v-select
        class="selectCustom"
        outlined
        dense
        height="46px"
        v-model="icon"
        :items="iconsList"
        :item-value="(i) => i.value"
        append-icon="fas fa-angle-down"
        menu-props="offset-y"
        :rules="[inputRules.required]"
      >
        <template v-slot:selection="{ item }">
          <img :src="require('~/assets/img/setting/freeDocument/' + item)" />
        </template>
        <template v-slot:item="{ item }">
          <img :src="require('~/assets/img/setting/freeDocument/' + item)" />
        </template>
      </v-select>
    </div>
    <div v-if="adminRequestType">
      <label class="fw500 primary--text f14">{{
        localStorage.translations.pages['setting-free_documents']['dialogs_labels']['access']
      }}</label>
      <transition name="fade" mode="out-in">
        <v-skeleton-loader v-if="!commonUserGridAll" width="100%" height="86px" type="list-item" />
        <v-autocomplete
          v-else
          class="selectCustom"
          outlined
          dense
          :clearable="user_ids.length ? true : false"
          chips
          deletable-chips
          multiple
          :placeholder="
            localStorage.translations.pages.personnel_department
              .dialog_employeepositionappointment_inputs['ne-vybran']
          "
          v-model="user_ids"
          :items="usersList"
          :item-value="(i) => i.id"
          :item-text="(i) => (i.id === 'all' ? i.name : i.first_name + ' ' + i.last_name)"
          append-icon="fas fa-angle-down"
          menu-props="offset-y"
          :rules="[inputRules.required]"
        ></v-autocomplete>
      </transition>
    </div>
  </TemplateModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseInput from 'components/base/BaseInput'

export default {
  name: 'DocumentsGroupModal',
  components: { BaseInput },
  props: {
    showBtnType: String,
    create: Boolean,
    group: { type: Object },
    functionDownloadPageData: Function,
  },
  data: () => ({
    valid: true,
    dialog: false,
    name: null,
    icon: null,
    iconsList: [
      'free.png',
      'personal.png',
      'project.png',
      'manual.png',
      'notes.png',
      'home.png',
      'personal_folder.png',
      'folder.png',
      'shared_folder.png',
      'warning.png',
      'prohibition_sign.png',
      'user.png',
      'prohibited_way.png',
      'celebration.png',
      'exclamation.png',
      'person_walking.png',
      'blueprint.png',
      'car.png',
      'helmet.png',
      'instruments.png',
    ],
    user_ids: [],
    data: {},
  }),
  computed: {
    ...mapGetters(['apiDomain', 'inputRules']),
    ...mapGetters('commonUser', ['commonUserGridAll']),
    ...mapGetters('user', ['userData']),
    t() {
      return this.localStorage.translations.pages['setting-free_documents']
    },
    text() {
      return {
        button: {
          open: this.t['dialogs_buttons']['create_group'],
        },
        title: {
          create: this.t['dialogs_titles']['create_group'],
          edit: this.t['dialogs_titles']['edit_group'],
        },
      }
    },
    usersList() {
      let array = [
        {
          id: 'all',
          name: this.localStorage.translations.pages.common.text.to_all,
        },
      ]

      return array.concat(this.commonUserGridAll)
    },
    accessCheck() {
      return this.$userCheckAccess({
        abilities: ['view_users', 'edit_free_documents'],
      })
    },
    adminRequestType() {
      return this.$route.meta.requestType === 'admin'
    },
  },
  watch: {
    user_ids(newData, oldData) {
      if (newData.length > 1) {
        if (oldData.indexOf('all') == -1 && newData.indexOf('all') >= 0) {
          this.user_ids = ['all']
        } else if (oldData.find((i) => i === 'all')) {
          let indexAll = this.user_ids.indexOf('all')
          this.user_ids.splice(indexAll, 1)
        }
      }
    },
  },
  methods: {
    ...mapActions('freeDocumentsGroups', [
      'onFreeDocumentsGroupsGrid',
      'onFreeDocumentsGroupsCreate',
      'onFreeDocumentsGroupsUpdate',
    ]),
    ...mapActions('commonUser', ['onCommonUserGridAll']),
    onOpen() {
      if (this.adminRequestType) {
        this.onCommonUserGridAll()
      }
      if (this.group) {
        this.name = this.group.name
        this.icon = this.group.icon
        if (this.group.users) {
          this.user_ids = this.group.users.length ? this.group.users.map((i) => i.id) : ['all']
        }
      }
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
    },
    openModal(group) {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
      this.name = null
      this.icon = null
      this.user_ids = []
      this.valid = true
    },
    validate() {
      this.$refs.form.validate()
    },
    async onGroupCreateAndUpdate() {
      if (this.valid === true) {
        let data = {
          name: this.name,
          icon: this.icon,
          user_ids: this.adminRequestType
            ? this.user_ids.indexOf('all') >= 0
              ? []
              : this.user_ids
            : [this.userData.id],
        }
        if (this.create) {
          this.onFreeDocumentsGroupsCreate(data)
            .then((response) => {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications['uspeshno-dobavlen'],
                  IsError: false,
                },

                { root: true },
              )
              this.functionDownloadPageData()
              this.closeModal()
            })
            .catch((err) => {
              console.log('err', err)
              if (
                err &&
                err.response &&
                err.response.data &&
                err.response.data.name &&
                err.response.data.name[0]
              ) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'name_is_already_in_use'
                      ],
                    IsError: true,
                  },
                  { root: true },
                )
              } else {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message: this.localStorage.translations.pages.common.notifications['oshibka'],
                    //  + ' ' + err.response.data.message
                    IsError: true,
                  },
                  { root: true },
                )
              }
            })
        } else {
          data.id = this.group.id
          this.onFreeDocumentsGroupsUpdate(data)
            .then(() => {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'izmeneniya-uspeshno-sohraneny'
                    ],
                  IsError: false,
                },

                { root: true },
              )
              this.functionDownloadPageData()
              this.closeModal()
            })
            .catch((err) => {
              console.log('err', err)
              if (
                err &&
                err.response &&
                err.response.data &&
                err.response.data.name &&
                err.response.data.name[0]
              ) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'name_is_already_in_use'
                      ],
                    IsError: true,
                  },
                  { root: true },
                )
              } else {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message: this.localStorage.translations.pages.common.notifications['oshibka'],
                    IsError: true,
                  },
                  { root: true },
                )
              }
            })
        }
      }
    },
  },
}
</script>
